import { type FC } from "react";

import { Alert } from "@snapchat/snap-design-system";
// eslint-disable-next-line no-restricted-imports -- Needed to extend the AlertWithExpiration props
import { type AlertProps } from "@snapchat/snap-design-system/es/components/Alert";

interface AlertWithExpiration extends AlertProps {
    startDate?: string;
    endDate: string;
}

export const AlertWithExpiration: FC<AlertWithExpiration> = ({ startDate, endDate, ...alertProps }) => {
    const today = new Date();
    const startDateObj = startDate ? new Date(startDate) : today;
    const endDateObj = new Date(endDate);

    if (startDateObj > today || endDateObj < today) {
        return null;
    }

    return <Alert {...alertProps} />;
};
